var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "report-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.6663 10.6667L18.6663 2.66675H7.99967C7.29243 2.66675 6.61415 2.9477 6.11406 3.4478C5.61396 3.94789 5.33301 4.62617 5.33301 5.33341V26.6667C5.33301 27.374 5.61396 28.0523 6.11406 28.5524C6.61415 29.0525 7.29243 29.3334 7.99967 29.3334H23.9997C24.7069 29.3334 25.3852 29.0525 25.8853 28.5524C26.3854 28.0523 26.6663 27.374 26.6663 26.6667V10.6667ZM11.9997 25.3334H9.33301V13.3334H11.9997V25.3334ZM17.333 25.3334H14.6663V17.3334H17.333V25.3334ZM22.6663 25.3334H19.9997V21.3334H22.6663V25.3334ZM18.6663 12.0001H17.333V5.33341L23.9997 12.0001H18.6663Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports1);
export default __webpack_public_path__ + "static/media/reports1.9550db86789f012ef18a7b9ffe5399b9.svg";
export { ForwardRef as ReactComponent };